import * as types from "./actions";
import { MAX_11_DIGITS } from "../../../../utils/constants";

const defaultState = {
    list: [],
    products: [],
    pageCount: 0,
    pageSize: 20,
    tableHeader: [
        {
            label: "対象",
            checkbox: true
        },
        {
            label: "ゲループID",
            button: false,
            id: true
        },
        {
            label: "グループ名",
            button: false
        },
        {
            label: "提案期間",
            button: false
        },
        {
            label: "編集",
            button: true
        },
        {
            label: "コピー",
            button: true
        }
    ],
    tableColumns: [
        "checkbox",
        "proposalId",
        "proposalName",
        "proposalDate"
    ],
    dayValues: [
        {
            name: "deadlineDay",
            value: 0,
            label: "当日"
        },
        {
            name: "deadlineDay",
            value: 1,
            label: "1日前"
        },
        {
            name: "deadlineDay",
            value: 2,
            label: "2日前"
        },
        {
            name: "deadlineDay",
            value: 3,
            label: "3日前"
        },
    ],
    dayFlags: [
        "monFlag",
        "tueFlag",
        "wedFlag",
        "thuFlag",
        "friFlag",
        "satFlag",
        "sunFlag"
    ],
    minuteValues: [
        {
            name: "deadlineMinute",
            value: "00",
            label: "00"
        },
        {
            name: "deadlineMinute",
            value: "15",
            label: "15"
        },
        {
            name: "deadlineMinute",
            value: "30",
            label: "30"
        },
        {
            name: "deadlineMinute",
            value: "45",
            label: "45"
        },
    ],
    productTableHeader: [
        {
            label: "商品コード",
            button: false,
            id: true,
            rightAlign: true,
            contentClass: "table-idResponsive"
        },
        {
            label: "商品名１",
            button: false,
        },
        {
            label: "商品名２",
            button: false
        },
        {
            label: "価格",
            button: false,
            id: true
        },
        {
            label: "発注制御パターン",
            required: true,
            button: false
        },
        {
            label: "削除",
            button: true
        }
    ],
    productTableColumns: [
        "strProductCode",
        "productName1",
        "productName2",
        "productPrice",
        "orderControlSelect"
    ],
    partnerTableHeader: [
        {
            label: "取引先コード\n（主番）",
            button: false,
            id: true,
            rightAlign: true
        },
        {
            label: "取引先コード\n（枝番）",
            button: false,
            id: true,
            rightAlign: true
        },
        {
            label: "取引先名",
            button: false
        },
        {
            label: "削除",
            button: true
        }
    ],
    partnerTableColumns: [
        "customerCode1",
        "customerCode2",
        "customerName",
    ],
    addProductForm:[
        {
            componentClass: "select",
            type: "select",
            label: "商品分類",
            placeholder: "",
            name: "productClassCode",
            disabled: false
        },
        {
            type: "text",
            label: "商品名１",
            placeholder: "",
            minLength: 0,
            maxLength: 40,
            name: "productName1",
            disabled: false
        }, {
            type: "text",
            label: "商品名２",
            placeholder: "",
            minLength: 0,
            maxLength: 40,
            name: "productName2",
            disabled: false
        },
        {
            type: "text",
            label: "フリガナ",
            placeholder: "",
            minLength: 0,
            maxLength: 20,
            name: "productKana",
            disabled: false
        },
    ],
    addProductTableHeader: [
        {
            label: "商品分類名",
            button: false
        },
        {
            label: "商品コード",
            button: false,
            id: true,
            rightAlign: true
        },
        {
            label: "商品名１",
            button: false
        },
        {
            label: "商品名２",
            button: false
        },
        {
            label: "追加",
            button: true
        }
    ],
    addProductTableColumns: [
        "productClassName",
        "strProductCode",
        "productName1",
        "productName2",
    ],
    addPartnerForm:[
        {
            type: "number",
            label: "取引先コード（主番）",
            placeholder: "",
            min: 0,
            max: MAX_11_DIGITS,
            name: "customerCode1"
        }, {
            type: "number",
            label: "取引先コード（枝番）",
            placeholder: "",
            min: 0,
            max: MAX_11_DIGITS,
            name: "customerCode2"
        },
        {
            type: "text",
            label: "取引先名",
            placeholder: "",
            minLength: 1,
            maxLength: 40,
            name: "customerName",
        },
        {
            type: "text",
            label: "フリガナ",
            placeholder: "",
            minLength: 0,
            maxLength: 20,
            name: "customerKana",
            disabled: false
        },
    ],
    addPartnerTableHeader: [
        {
            label: "取引先コード（主番）",
            button: false,
            rightAlign: true
        },
        {
            label: "取引先コード（枝番）",
            button: false,
            rightAlign: true
        },
        {
            label: "取引先名",
            button: false
        },
        {
            label: "追加",
            button: true
        }
    ],
    addPartnerTableColumns: [
        "customerCode1",
        "customerCode2",
        "customerName",
    ],
}

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case types.LIST:
            return { ...state, list: action.payload.list, pageCount: action.payload.pageCount };
        case types.SIZE:
            return { ...state, pageSize: action.payload };
        default: // need this for default case
            return state
    }
};
